import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared.module';
import { MessengerDropdownItemComponent } from './components/messenger-dropdown-item/messenger-dropdown-item.component';
import { MessengerDropdownComponent } from './components/messenger-dropdown/messenger-dropdown.component';

@NgModule({
  declarations: [MessengerDropdownComponent, MessengerDropdownItemComponent],
  imports: [CommonModule, NgbDropdownModule, RouterModule, SharedModule],
  exports: [MessengerDropdownComponent],
})
export class EventMessengerModule {}
